import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { AnswersDTO } from './useRiskToleranceWorkflowQuery';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

interface SubmitResponsesParams {
  clientId: string;
  answers: AnswersDTO;
}

interface AssetDTO {
  name: string;
  y: number;
  color_group: number;
  color: string | null;
}

export interface PortfolioDTO {
  Name: string;
  NormalizedName: string;
  Description: string;
  Family: string;
  FamilyId: string;
  AssetAllocation: AssetDTO[];
  ExpectedReturn: string;
  StandardDeviation: string;
  Score: number;
}

const submitAnswers = ({ clientId, answers }: SubmitResponsesParams): Promise<PortfolioDTO> => {
  return authFetch(
    urlWithParams('/Consumer/RiskToleranceWorkflowUpdate/PostResponsesAndGetPortfolio', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(answers, true) },
  );
};

export const useSubmitAnswersMutation = () => {
  return useMutation(submitAnswers);
};
